module.exports = __webpack_public_path__ + "img/26.891ea06b.jpg";